import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { Provider } from 'react-redux';
import Store from './store/reducers/RootReducer'

import './style/style.scss'

import Home from './pages/Home'
import DIDsHome from './pages/DIDsHome'
import PBXHome from './pages/PBXHome'

import Navbar from './components/Navbar'
import Footer from './components/Footer'

import { APP_BASENAME } from './store/reducers/statics/consts'

function App() {
  return (
	<Provider store={Store}>
		<div className="App">
			<BrowserRouter basename={"/"/* + APP_BASENAME*/}>
				<Navbar />
				<div id="container">
					<Switch>
						{/*<Route exact path="/" component={Home} />*/}
						<Route path={`/${APP_BASENAME}/:step?`} component={Home} />
						<Route path="/phone-numbers" component={DIDsHome} />
						<Route path="/pbx" component={PBXHome} />
						<Route path="*" component={Home} />
					</Switch>
				</div>
				<Footer />
			</BrowserRouter>
		</div>
	</Provider>
  );
}

export default App;
